import React from 'react'
import Link from 'next/link'
import { useInView } from 'react-intersection-observer'

export default function RowList (props) {
  const [slideUpRef, isInView] = useInView({ triggerOnce: true })
  const {
    title,
    subheading,
    body,
    link,
    button,
    target,
    active = 'inactive',
    inactiveText = 'Check back next year'
  } = props
  return (
    <React.Fragment>
      <div
        ref={slideUpRef}
        className={`${isInView ? 'slide-up' : ''} animation row ${
          props.partners ? 'partners__intro' : 'scholarship'
        }`}
      >
        <div
          className={`col-10 col-lg-3   scholarship__heading ${
            props.singlePage ? 'offset-lg-1' : 'offset-1 offset-lg-2'
          }`}
        >
          {subheading ? (
            <h1
              className='heading3'
              dangerouslySetInnerHTML={{ __html: subheading }}
            />
          ) : (
            ''
          )}

          {props.singlePage ? (
            <h1
              className='heading2'
              dangerouslySetInnerHTML={{ __html: title }}
            ></h1>
          ) : (
            <h2
              className='heading2'
              dangerouslySetInnerHTML={{ __html: title }}
            ></h2>
          )}
        </div>
        <div className='col-10 col-lg-5 offset-1 offset-lg-0 scholarship__description'>
          <div dangerouslySetInnerHTML={{ __html: body }} />

          <div className='scholarship__link'>
            {/*If RowList has scholarship prop, then a greyed out button will display if there is no link, otherwise no button will display if there's no link*/}
            {props.scholarship ? (
              link && active == 'active' ? (
                <Link href={link} passHref>
                  <a className='link'>{button}</a>
                </Link>
              ) : (
                <p className='link--inactive'>{inactiveText}</p>
              )
            ) : link ? (
              target == '_blank' ? (
                <a href={link} target='_blank' className='link'>
                  {button}
                </a>
              ) : (
                <Link href={link} passHref>
                  <a className='link'>{button}</a>
                </Link>
              )
            ) : (
              ''
            )}
          </div>
        </div>

        {props.partners ? (
          <div className='col-10 offset-1 col-lg-8 offset-lg-2'>
            <hr />
          </div>
        ) : (
          ''
        )}
      </div>
      <style jsx>{`
        hr {
          border-top: 1px solid #4e87a0;
          margin-top: 43px;
        }
      `}</style>
    </React.Fragment>
  )
}
